export let Color;
(function (Color) {
  Color["BLUE_0"] = "#E2F2FE";
  Color["BLUE_1"] = "#B9DDFC";
  Color["BLUE_2"] = "#5FB3F9";
  Color["BLUE_3"] = "#1061C3";
  Color["BLUE_4"] = "#0B347D";
  Color["BROWN_0"] = "#F2E8DE";
  Color["BROWN_1"] = "#EEDCCA";
  Color["BROWN_2"] = "#D0AF8F";
  Color["BROWN_3"] = "#974C00";
  Color["BROWN_4"] = "#592C00";
  Color["GREEN_0"] = "#E7F5E9";
  Color["GREEN_1"] = "#C6E7C8";
  Color["GREEN_2"] = "#7ED085";
  Color["GREEN_3"] = "#40B14B";
  Color["GREEN_4"] = "#237F2E";
  Color["GREY_0"] = "#FFFFFF";
  Color["GREY_1"] = "#E5E5E5";
  Color["GREY_2"] = "#BDBDBD";
  Color["GREY_3"] = "#757575";
  Color["GREY_4"] = "#000000";
  Color["LEGACY_AQUA"] = "#95B9F0";
  Color["LEGACY_BLUE_GREY"] = "#808080";
  Color["LEGACY_DARK_GREEN"] = "#00750D";
  Color["LEGACY_DARK_TEAL"] = "#00395E";
  Color["LEGACY_DARK_YELLOW"] = "#A9EEAE";
  Color["LEGACY_GREY_40_PERCENT"] = "#808080";
  Color["LEGACY_GREY_80_PERCENT"] = "#808080";
  Color["LEGACY_INDIGO"] = "#00395E";
  Color["LEGACY_LIGHT_BLUE"] = "#165DEF";
  Color["LEGACY_LIGHT_ORANGE"] = "#FF8100";
  Color["LEGACY_OLIVE_GREEN"] = "#00750D";
  Color["LEGACY_ROSE"] = "#FCABAE";
  Color["LEGACY_SEA_GREEN"] = "#00750D";
  Color["LEGACY_SKY_BLUE"] = "#95B9F0";
  Color["LEGACY_TEAL"] = "#A9EEAE";
  Color["LEGACY_TURQUOISE"] = "#95B9F0";
  Color["ORANGE_0"] = "#FFF3DF";
  Color["ORANGE_1"] = "#FFE1AF";
  Color["ORANGE_2"] = "#FFCD7A";
  Color["ORANGE_3"] = "#FF8D00";
  Color["ORANGE_4"] = "#EA5000";
  Color["PURPLE_0"] = "#F4E4F5";
  Color["PURPLE_1"] = "#EBC7EF";
  Color["PURPLE_2"] = "#D190DA";
  Color["PURPLE_3"] = "#9210AD";
  Color["PURPLE_4"] = "#61058B";
  Color["RED_0"] = "#FFEBEE";
  Color["RED_1"] = "#FFCCD2";
  Color["RED_2"] = "#F87E7D";
  Color["RED_3"] = "#EA352E";
  Color["RED_4"] = "#991310";
  Color["TRANSPARENT"] = "";
  Color["YELLOW_0"] = "#FFFEE6";
  Color["YELLOW_1"] = "#FEFF85";
  Color["YELLOW_2"] = "#FEFF00";
  Color["YELLOW_3"] = "#FFED00";
  Color["YELLOW_4"] = "#EBC700";
})(Color || (Color = {}));
//# sourceMappingURL=Color.js.map